import { NavLink } from 'react-router-dom'
import { Home, CalendarDays, Users, Settings, type LucideIcon } from 'lucide-react'
import { cn } from '@/utils/cn'

interface TabItem {
  key: string
  label: string
  to: string
  icon: LucideIcon
}

// SideNav と同じ実ルートに接続 (今日/会議/相手/設定)。
const TAB_ITEMS: TabItem[] = [
  { key: 'today', label: '今日', to: '/dashboard', icon: Home },
  { key: 'meetings', label: '会議', to: '/realtime/setup', icon: CalendarDays },
  { key: 'contacts', label: '相手', to: '/contacts', icon: Users },
  { key: 'settings', label: '設定', to: '/account', icon: Settings },
]

/**
 * モバイル (md 未満) 用のボトムタブナビ。画面下部に固定し、4 項目を等幅配置。
 * デスクトップでは AppLayout が `md:hidden` で隠す。
 */
export function BottomTabBar({ className }: { className?: string }) {
  return (
    <nav
      aria-label="モバイルナビゲーション"
      className={cn(
        'fixed inset-x-0 bottom-0 z-30 flex border-t border-v2-border bg-v2-surface',
        className,
      )}
    >
      {TAB_ITEMS.map(({ key, label, to, icon: Icon }) => (
        <NavLink
          key={key}
          to={to}
          className={({ isActive }) =>
            cn(
              'flex min-h-[56px] flex-1 flex-col items-center justify-center gap-1 text-xs font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-v2-primary',
              isActive ? 'text-v2-primary' : 'text-v2-ink-muted hover:text-v2-ink',
            )
          }
        >
          <Icon className="h-5 w-5" aria-hidden="true" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
